import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { getListaDetalle } from "../../services/lista_detalle";
import { set } from "date-fns";
import { useSelector } from "react-redux";
import { selectUsuarioSeleccionado } from "../../redux/reducer/loginReducer";
import { useLocation } from 'react-router-dom';
import { crearDudaInterna } from "../../services/dudas_internas";
import Swal from "sweetalert2";

const FabDialogDudaInterna = () => {
    /* --------------------------------- Estados -------------------------------- */
    const [openModal, setOpenModal] = useState(false);
    const [categoria, setCategoria] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [asunto, setAsunto] = useState("");
    const [categorias,setCategorias] = useState([]);
    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });
    const location = useLocation();
    
    /* -------------------------- Abrir y cerrar modal -------------------------- */
    const handleOpenModal = () => {
        setCategoria("");
        setDescripcion("");
        setAsunto("");
        setOpenModal(true);
    };
    const handleCloseModal = () => setOpenModal(false);

    /* -------------------------- Envio del formulario -------------------------- */
    const handleSubmit = () => {
        // Aquí puedes agregar la lógica para enviar la duda
        console.log("Categoría:", categoria);
        console.log("Asunto:", asunto);
        console.log("Descripción:", descripcion);
        console.log("Usuario:", usuarioSeleccionado.id);
        console.log("Página:", window.location.href);

        crearDudaInterna({
            usuario_id: usuarioSeleccionado.id,
            categoria_id: categoria,
            url_origen: window.location.href,
            asunto: asunto,
            descripcion: descripcion,
        }).then((response) => {
            if (response && response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Duda enviada',
                    text: 'Tu duda ha sido enviada correctamente. Te responderemos a la brevedad.',
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Hubo un error al enviar tu duda. Por favor, intenta nuevamente más tarde.',
                });
            }
        });

        handleCloseModal();
    };

    /* ------------------------------ Carga inicial ----------------------------- */
    React.useEffect(() => {
        getListaDetalle({ usuario_id: 1, lista_id: 32 }).then((data) => {
            setCategorias(data.lista_detalle);
        })
    }, []);
    /* --------------------------------- Return --------------------------------- */
    return (
        <>
            <div style={{ position: "fixed", bottom: 20, right: 20 }}>
                <Fab variant="extended" onClick={handleOpenModal} style={{ backgroundColor: '#ECB3D0', color: 'black', '&:hover': { backgroundColor: '#ed9cc6ff' } }}>
                <HelpOutlineIcon sx={{ mr: 1 }} />
                Ayuda
                </Fab>
            </div>

            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                sx={{ width: 1200 }}
            >
                <DialogTitle id="alert-dialog-title">
                Envia tu duda o consulta
                </DialogTitle>
                <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                    <FormControl fullWidth>
                    <InputLabel id="categoria-label">Categoría</InputLabel>
                        <Select
                            labelId="categoria-label"
                            value={categoria}
                            label="Categoría"
                            onChange={(e) => setCategoria(e.target.value)}
                        >
                            {categorias.map((cat) => (
                                <MenuItem key={cat.id} value={cat.id}>{cat.nombre}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <TextField
                    label="Asunto"
                    value={asunto}
                    onChange={(e) => setAsunto(e.target.value)}
                    fullWidth
                    variant="outlined"
                    style={{ marginTop: 16 }}
                    />

                    <TextField
                    label="Descripción"
                    multiline
                    rows={10}
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    placeholder="Describe tu duda o consulta aquí..."
                    fullWidth
                    variant="outlined"
                    style={{ marginTop: 16 }}
                    />
                </Box>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseModal}>Cancelar</Button>
                <Button
                    onClick={handleSubmit}
                    autoFocus
                    disabled={!categoria || !descripcion || !asunto}
                    variant="contained"
                    color="primary"
                >
                    Enviar duda
                </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default FabDialogDudaInterna;
